import type { PaymentIntermediary } from './payment-intermediary';

export interface Provider {
  id: number;
  providerCode: string;
  providerCodeType: string;
  providerName: string;
}

export interface Account {
  accountNumber: string;
  accountStatus: string;
  credit: number;
  defineAsDefault: boolean;
  id: number;
  initialCredit: number;
  provider: Provider;
  providerAccountType: string;
  userId: string;
}

export interface NostroAccount {
  accountName: string;
  counterValue: unknown;
  crCredit: number;
  daCredit: number;
  fxValue: unknown;
  accounts: Account[];
}

/** @deprecated Use `PaymentIntermediary` from '@/types/payment-intermediary' instead. */
export type PaymentIntermediariesRecord = PaymentIntermediary;

export interface NostroAccountAdjustRequest {
  accountId: number;
  amount: number;
  idPaymentIntermediary: string;
}

export interface NostroOperationResult {
  uniqueReference?: string;
  transfer?: { uniqueReference: string };
}

export const NostroOperationType = {
  ADD_FUNDS: 'add_funds',
  WITHDRAW_FUNDS: 'withdraw_funds',
  ADJUST: 'adjust',
} as const;

export type NostroOperationType = (typeof NostroOperationType)[keyof typeof NostroOperationType];
